module.exports = __webpack_public_path__ + "static/img/dnsd_logo.43e4ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dnsd_logo.png
// module id = +PWU
// module chunks = 1